import { Clipboard } from '@angular/cdk/clipboard';
import { Platform } from '@angular/cdk/platform';
import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationStart, Params, Router } from '@angular/router';
import { Ad } from '@core/models/ad.model';
import { User } from '@core/models/auth.model';
import { environment } from '@environments/environment';
import { NgbCarousel, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { BoostAdDialogComponent } from '@shared/components/boost-ad-dialog/boost-ad-dialog.component';
import { ButtonType } from '@shared/components/button/button.component';
import * as moment from 'moment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subscription } from 'rxjs';
import { GoogleAd } from 'src/app/core/enums';
import { HeaderService } from 'src/app/core/services/header.service';
import { AdsService } from '@shared/services/ads.service';
import { ApiService } from '@shared/services/api.service';
import { AuthService } from '@shared/services/auth.service';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
import { LocaleService } from '@shared/services/locale.service';
import { NumbersService } from '@shared/services/numbers.service';
import { ScrollService } from '@shared/services/scroll.service';
import { SnackService } from '@shared/services/snack.service';
import { TimeService } from '@shared/services/time.service';
import { ViewportService } from '@shared/services/viewport.service';

@Component({
	selector: 'app-ad',
	templateUrl: './ad.component.html',
	styleUrls: ['./ad.component.scss'],
})
export class AdComponent implements OnInit, OnDestroy {
	showMobileAd: string;
	embedded: boolean = false;
	showFullPhoneNumber: boolean = false;
	showCreatedAtDate: boolean = false;
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private dialog: MatDialog,
		private carousel_config: NgbCarouselConfig,
		private snack: SnackService,
		private title: Title,
		private api: ApiService,
		private auth: AuthService,
		private clipboard: Clipboard,
		public locale: LocaleService,
		public viewport: ViewportService,
		public scroll: ScrollService,
		public numbers: NumbersService,
		public time: TimeService,
		public adsService: AdsService,
		private platform: Platform,
		private header: HeaderService,
		private deviceDetectorService: DeviceDetectorService,
		public ads: AdsService
	) {
		this.carousel_config.interval = 0;
	}

	@ViewChild('carousel') carousel: NgbCarousel;

	private subscriptions: Subscription = new Subscription();
	redirect: string;
	redirectId: any;
	assignAd: string;
	loading: boolean = true;
	ad: any = [];
	status: any;
	timestamp: string;
	user: User = this.auth.user();
	exists: boolean;
	isMe: boolean = false;
	ios: boolean = this.platform.IOS;
	android: boolean = this.platform.ANDROID;
	commentListArr: any = [];
	comment: string;
	reply: string;
	commentID: number;
	Commentsdialog: any;
	visible: boolean = false;
	visibleye: boolean = false;
	show: boolean = true;
	result: string;
	tempstatus: any = 1;
	length: number;
	toggleButton: boolean = false;
	date: any;
	banner_visible: boolean = false;
	complete: boolean = false;
	call_data_updated: boolean = false;

	readonly googleAd = GoogleAd;
	readonly buttonType = ButtonType;

	handlePhoneNumberClicked($event: { clicked: boolean; number: string }): void {
		let number = $event.number;

		const regexPattern = /^964\d{10}$/;

		if (regexPattern.test(number)) {
			number = number.substring(3); // Trim the "964" prefix by taking the substring from index 3.
		}

		if (this.ad['data']['paymentHold'] === 1) {
			this.sendFormDataToBackend({ id: this.ad['data']['adID'], descriptionNumber: number }, false, 'notify-seller');
			return;
		}

		this.sendFormDataToBackend({ id: this.ad['data']['adID'], descriptionNumber: number });

		if (this.viewport.type === 'mobile') {
			this.callAdOwner();
		}
	}

	showComment() {
		const commentFormData: FormData = new FormData();
		commentFormData.append('adID', this.ad['data']['adID']);
		commentFormData.append('lang', this.locale.lang);
		commentFormData.append('commentLimit', '5');
		commentFormData.append('ownerUserID', this.ad['data']['userID']);
		if (this.user) {
			commentFormData.append('userID', this.user['userID']);
		}
		this.api.comments(commentFormData).subscribe((res) => {
			this.length = res['response']['totalRows'];
			this.commentListArr = res['response']['data'];
			for (let i = 0; i < res['response']['data']['length']; i++) {
				res['response']['data'][i]['createdAt'] = moment.unix(res['response']['data'][i]['createdAt']).fromNow(true);
			}
		});
	}

	onCopyAdIDToClipboard() {
		this.clipboard.copy(this.ad['data']['adID']);
		this.snack.open(this.locale.translations['ads']['ad']['s22']);
	}

	// fullscreen image slider (carousel) dialog
	onFullscreen(id: string) {
		const fsRef = this.dialog.open(FullscreenCarouselDialog, {
			maxWidth: '100vw',
			width: this.viewport.type !== 'mobile' ? '70%' : '100%',
			height: this.viewport.type !== 'mobile' ? '85%' : '100%',
			data: {
				images: this.ad['images'],
				slideID: id,
				ad: { ...this.ad.data, seller: this.ad.seller },
			},
		});

		fsRef.afterClosed().subscribe((result) => {
			setTimeout(() => {
				this.carousel.select(result);
			}, 500);
		});
	}

	apprColor(): string {
		return this.ad['data']['vip'] === '1' ? 'accent' : 'primary';
	}

	// call button clicked
	callAdOwner(ads?) {
		if (!ads) {
			window.location.href = 'tel:' + this.ad['data']['phone'];
		} else {
			window.location.href = 'tel:' + ads['seller']['phone'];
		}
	}

	OnContact(ad?) {
		this.sendFormDataToBackend(ad, false);
		this.callAdOwner();
	}

	onClickingPhoneNumber(ad?): void {
		this.sendFormDataToBackend(ad, false, 'direct-call');
	}

	notifySeller() {
		this.sendFormDataToBackend(undefined, false, 'notify-seller');
	}

	sendFormDataToBackend(ads?, isWhatsapp?, from?: string): void {
		let formData: FormData = new FormData();
		if (!ads) {
			formData.append('lang', this.locale.lang);
			formData.append('adId', this.ad['data']['adID']);
			formData.append('platform', 'Web');
			formData.append('phone', this.ad['data']['phone']);
			formData.append('callType', isWhatsapp ? '1' : '0');
		} else {
			formData.append('lang', this.locale.lang);
			formData.append('adId', ads['id']);
			formData.append('platform', 'Web');
			formData.append('phone', ads?.descriptionNumber ? ads?.descriptionNumber : this.ad['data']['phone']);
			formData.append('callType', isWhatsapp ? '1' : '0');
		}

		this.api.call(formData).subscribe((res) => {
			if (res.status === '0') {
				this.snack.open(res.message);
				return;
			}

			this.ad['data'] = {
				...this.ad['data'],
				callsCount: ++this.ad['data']['callsCount'],
			};

			if (from === 'notify-seller') {
				this.snack.open(this.locale.translations['ads']['ad']['n660']);
			}

			if (from === 'direct-call') {
				this.showFullPhoneNumber = true;
			}

			if (this.viewport.type === 'mobile' && !isWhatsapp) {
				this.callAdOwner();
			}
		});
	}

	onWhatsappCall(ads?) {
		const targetDisplay = this.deviceDetectorService.isMobile() ? '_self' : '_blank';

		if (this.ad['data']['paymentHold'] === 1 || this.ad['seller']['id'] === this.user?.['userID']) {
			this.sendFormDataToBackend(undefined, true);
			if (this.ad['data']['seller']['id'] !== this.user?.['userID']) {
				this.snack.open(this.locale.translations['ads']['ad']['n662']);
			}
			return;
		}

		if (!ads) {
			if (this.ad['data']['phonePrefix'] === null) {
				var callPrefix = '964';
			} else {
				callPrefix = this.ad['data']['phonePrefix'].substring(1);
			}
			let whatsapp = this.ad['data']['phone'].substring(1);

			let templateMessage = this.locale.translations['ads']['ad']['n418'] + '%0a' + encodeURIComponent(this.ad['data']['adLink']);

			window.open(`${environment.WHATSAPP.callForDetails}${callPrefix}${whatsapp}&text=${templateMessage}`, targetDisplay);
		} else {
			if (ads['seller']['phonePrefix'] === null) {
				var callPrefix = '964';
			} else {
				callPrefix = ads['seller']['phonePrefix'].substring(1);
			}
			let whatsapp = ads['seller']['phone'].substring(1);

			let templateMessage = this.locale.translations['ads']['ad']['n418'] + '%0a' + encodeURIComponent(ads.adLink);

			window.open(`${environment.WHATSAPP.callForDetails}${callPrefix}${whatsapp}&text=${templateMessage}`, targetDisplay);
		}

		this.sendFormDataToBackend(ads, true);
	}

	// watch button clicked
	onWatch(event, index: number = undefined) {
		event.stopPropagation();
		if (this.user) {
			const watchFormData: FormData = new FormData();
			watchFormData.append('lang', this.locale.lang);
			watchFormData.append('userID', this.user['userID']);
			watchFormData.append('adID', index === undefined ? this.ad['data']['adID'] : this.ad['related'][index]['id']);
			watchFormData.append(
				'watch',
				index === undefined ? (this.ad['data']['watching'] === '1' ? '0' : '1') : this.ad['related'][index]['watching'] === '1' ? '0' : '1'
			);

			this.api.watch(watchFormData).subscribe((res) => {
				if (res['status'] === '1') {
					if (index === undefined ? this.ad['data']['watching'] === '1' : this.ad['related'][index]['watching'] === '1') {
						index === undefined ? (this.ad['data']['watching'] = '0') : (this.ad['related'][index]['watching'] = '0');
					} else {
						index === undefined ? (this.ad['data']['watching'] = '1') : (this.ad['related'][index]['watching'] = '1');
					}

					this.snack.open(res['message']);
				}
			});
		} else {
			this.snack.open(this.locale.translations['ads']['s1']);
		}
	}

	onDelete(adID: string) {
		const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
			width: this.locale.lang == 'ku' ? '385px' : '320px',
			height: '140px',
			data: {
				message: this.locale.translations['ads']['ad']['n386'],
				yes: this.locale.translations['ads']['ad']['n388'],
				no: this.locale.translations['ads']['ad']['n387'],
				colors: {
					yes: 'warn',
					no: 'warn',
				},
			},
		});

		dialogRef.afterClosed().subscribe((result) => {
			// ad sold
			if (result === true) {
				const sellFormData: FormData = new FormData();
				sellFormData.append('lang', this.locale.lang);
				sellFormData.append('userID', this.user['userID']);
				sellFormData.append('adID', adID);

				this.api.sell(sellFormData).subscribe((res) => {
					if (res['status'] === '1') {
						this.snack.open(this.locale.translations['user']['user-ads']['delete-ad']['s18']);
						this.router.navigate(['/user/' + this.user['userID'] + '/ads']);
					}
				});

				// ad not sold
			} else if (result === false) {
				const dialogRef_1 = this.dialog.open(ConfirmationDialogComponent, {
					width: this.locale.lang == 'ku' ? '385px' : '320px',
					height: '160px',
					data: {
						message: this.locale.translations['n722'],
						yes: 'Yes',
						no: 'No',
						colors: {
							yes: 'warn',
						},
					},
				});

				dialogRef_1.afterClosed().subscribe((result) => {
					if (result) {
						const deleteAdFormData: FormData = new FormData();
						deleteAdFormData.append('lang', this.locale.lang);
						deleteAdFormData.append('userID', this.user['userID']);
						deleteAdFormData.append('adID', adID);

						this.api.deleteAd(deleteAdFormData).subscribe((res) => {
							if (res['status'] === '1') {
								this.snack.open(this.locale.translations['user']['user-ads']['delete-ad']['s15']);
								this.router.navigate(['/user/' + this.user['userID'] + '/ads']);
							}
						});
					}
				});
			}
		});
	}

	//check add complete or incomplete
	onAddComplete(ad) {
		if (ad['title'] !== null && ad['location'] !== '' && ad['subCatID'] !== 0 && ad['image'] !== '' && ad['description'] !== null && ad['price'] !== '0') {
			this.complete = true;
		} else {
			this.complete = false;
		}
		return this.complete;
	}

	getObjectLength(obj) {
		if (Object.keys(obj).length === 0) {
			return true;
		}
	}

	/**
	 * Check if the ancestor element is intersecting to each other
	 *
	 * @param isIntersecting Boolean if two elements are intersecting
	 */
	onAdHeaderIntersect(isIntersecting: boolean) {
		// Hide the header navigation if ad header not intersecting to it's ancestor element
		this.header.setToggleHeader(isIntersecting);
	}

	onOpenBoostAdDialog(ad) {
		this.dialog.open(BoostAdDialogComponent, {
			maxWidth: '425px',
			width: '96%',
			maxHeight: '700px',
			data: {
				adID: ad['data']['adID'],
				catId: ad['data']['catID'],
				lang: this.locale.lang,
				package: 'vip',
			},
		});
	}

	isWithinTenDays(createdDate: string) {
		const currentDate = new Date();
		const parsedDate = new Date(createdDate);

		// Calculate the difference in milliseconds
		const difference = currentDate.getTime() - parsedDate.getTime();

		// Convert milliseconds to days
		const differenceInDays = Math.floor(difference / (1000 * 60 * 60 * 24));

		if (differenceInDays <= 10) {
			this.showCreatedAtDate = true;
		}
	}

	ngOnInit(): void {
		const EDIT_AD_DESCRIPTION = this.adsService?.editAdDescription;
		const EDIT_AD_TITLE = this.adsService?.editAdTitle;

		const IS_EDIT_AD = this.adsService?.isEditAd;
		//hide the chat intercom for complete ap
		this.auth.bootIntercom(true);
		// for banner at top for redirect to appstore/playstore

		// listen for browser back/forward events
		this.subscriptions.add(
			this.router.events.subscribe((event: NavigationStart) => {
				const _scroll = this.scroll.fetch();

				// check if browser back/forward event triggered and if destination url = stored url
				if (event.navigationTrigger === 'popstate' && _scroll !== undefined && _scroll?.['url'] === event?.['url']) {
					this.scroll.save(null, null, null, true);
				}
			})
		);
		this.route.params.subscribe((params: Params) => {
			this.route.queryParams.subscribe((queries: Params) => {
				if (queries['redirect'] !== undefined) {
					this.redirect = queries['redirect'];
				}

				if (queries['from']) {
					this.redirect = queries['from'];
				}

				if (queries['id'] !== undefined) {
					this.assignAd = queries['id'];
				}
			});
			this.redirectId = params['id'];

			//   console.log(isDevMode())

			const adFormData: FormData = new FormData();

			// send user ID if logged in
			if (this.user) {
				adFormData.append('userID', this.user['userID']);
			}

			// send ad ID from route params
			adFormData.append('adID', params['id']);
			adFormData.append('lang', this.locale.lang);
			this.api.ad(adFormData).subscribe(
				(res) => {
					this.loading = false;
					if (res['status'] === '1') {
						this.ad = res['response'];
						if (IS_EDIT_AD) {
							this.ad['data']['description'] = EDIT_AD_DESCRIPTION;
							this.ad['data']['title'] = EDIT_AD_TITLE;
							this.adsService.editAdDescription = '';
							this.adsService.editAdTitle = '';
							this.adsService.isEditAd = false;
						}
						// check if ad is being viewed by the seller
						if (this.user && this.user['userID'] === this.ad['seller']['id']) {
							this.isMe = true;
						}

						// set page title
						this.title.setTitle(this.ad['data']['title'] + ' | ' + this.locale.translations['header']['n0']);
						//modifying the default meta details in header
						//this.meta.updateTag({ property: 'og:title', content: this.ad['data']['title'] });
						//this.meta.updateTag({ property: 'og:description', content: this.ad['data']['location'] });
						//this.meta.updateTag({ property: 'og:image', content: '/assets/images/logos/favicon.png' });

						this.exists = true;
						// this.showComment();
					} else {
						this.exists = false;
						this.ad = res['response'];
					}
					if (this.ad['data']['vipPlus'] === '1') {
						this.isWithinTenDays(this.ad['data']['createdDate']);
					}
				},
				(err) => {
					this.exists = false;
					this.loading = false;
				}
			);
		});

		// this.breakpointObserver.observe(['(max-width: 480px)', '(max-width: 840px)']).subscribe((res) => {
		// 	if (res['breakpoints']['(max-width: 480px)'] === true) {
		// 		this.auth.bootIntercom(true);
		// 	} else {
		// 		this.auth.bootIntercom(false);
		// 	}
		// });

		setTimeout(() => {
			window.scrollTo(0, 0);
		}, 100);
	}

	ngOnDestroy(): void {
		this.auth.bootIntercom(false);
		this.subscriptions.unsubscribe();
		this.header.setToggleHeader(true);
	}
}

@Component({
	selector: 'fullscreen-carousel-fullscreenDialog',
	templateUrl: './fullscreen-carousel-dialog.html',
})
export class FullscreenCarouselDialog implements OnInit {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public carousel_config: NgbCarouselConfig,
		private dialogRef: MatDialogRef<AdComponent>,
		private elementRef: ElementRef,
		public viewport: ViewportService,
		public snackService: SnackService,
		public localeService: LocaleService,
		private api: ApiService,
		private readonly deviceDetectorService: DeviceDetectorService,
		private readonly matDialog: MatDialog,
		private route: ActivatedRoute,
		private router: Router,
		private auth: AuthService,
		private scroll: ScrollService
	) {
		this.carousel_config.interval = 0;
	}

	currentSlideID: number = 0;
	readonly buttonType = ButtonType;
	toggleFullPhoneNumber = false;
	user: User = this.auth.user();
	public cache: Map<string, Observable<any>> = new Map();

	onChange($event) {
		this.currentSlideID = +$event['current'];
	}

	onClose() {
		this.dialogRef.close(this.currentSlideID);
	}

	onCall(ad: Ad): void {
		if (ad['paymentHold'] === 1 || ad['seller']['id'] === this.user?.['userID']) {
			this.toggleFullPhoneNumber = false;
			this.callApi(ad, 0);
			if (ad['seller']['id'] !== this.user?.['userID']) {
				this.snackService.open(this.localeService.translations['ads']['ad']['n662']);
			}
			return;
		}

		this.toggleFullPhoneNumber = true;
		//make direct call only on mobile
		if (this.viewport.type === 'mobile') {
			window.location.href = `tel:${ad.phone}`;
		}
		this.callApi(ad, 0);
	}

	callApi(ad, isWhatsapp) {
		this.api
			.call({
				lang: this.localeService.lang,
				adId: ad.id || ad.adID,
				platform: 'Web',
				phone: ad.phone,
				callType: isWhatsapp ? 1 : 0,
			})
			.subscribe((res) => {
				if (res.status === '0') {
					this.snackService.open(res.message);
				}
			});
	}

	onCallPlatform(ad: Ad): void {
		if (ad['paymentHold'] === 1 || ad['seller']['id'] === this.user?.['userID']) {
			this.callApi(ad, 1);
			if (ad['seller']['id'] !== this.user?.['userID']) {
				this.snackService.open(this.localeService.translations['ads']['ad']['n662']);
			}
			return;
		}

		const phonePrefix = ad?.phonePrefix ? ad.phonePrefix.substring(1) : '964';
		const phoneNumber = ad.phone.substring(1);
		const templateMessage = encodeURIComponent(this.localeService.translations['ads']['ad']['n418'] + '\n' + ad.adLink);
		const targetDisplay = this.deviceDetectorService.isMobile() ? '_self' : '_blank';

		window.open(`${environment.WHATSAPP.callForDetails}${phonePrefix}${phoneNumber}&text=${templateMessage}`, targetDisplay);

		this.callApi(ad, 1);
	}

	ngOnInit() {
		this.dialogRef.backdropClick().subscribe((_) => {
			this.onClose();
		});

		// scroll to stored position
		const _scroll = this.scroll.fetch();
		if (_scroll !== undefined && _scroll?.['trigger'] === true) {
			setTimeout(() => {
				window.scrollTo({ left: _scroll['xpos'], top: _scroll['ypos'] });
			}, 0);
		}
	}
}
